import { Check } from 'lucide-react'

interface MobileSectionSelectButtonProps {
  selected: boolean
  onSelect: () => void
}

export function MobileSectionSelectButton({ selected, onSelect }: MobileSectionSelectButtonProps) {
  return (
    <button
      onClick={e => {
        e.stopPropagation()
        onSelect()
      }}
      className={`absolute top-1/2 right-3 z-20 flex h-[22px] w-[22px] -translate-y-1/2 items-center justify-center rounded-full border-2 transition-all duration-150 md:hidden ${
        selected
          ? 'scale-110 border-acid bg-acid shadow-[0_0_0_3px_var(--acid-soft)]'
          : 'border-white/60 bg-white/80 active:scale-95'
      }`}
      aria-label={selected ? 'Deselect section' : 'Select section'}
    >
      {selected && <Check size={12} className="text-ink-on-acid" strokeWidth={3} />}
    </button>
  )
}
